import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import type { ColorHex } from '@/types';

export type ColorMap = Map<string, ColorHex>;

export type ColorConfig = {
  IncidentTypeID?: ColorMap;
  SeverityLevel?: ColorMap;
};
export type ColorConfigKey = (typeof COLOR_CONFIG_KEYS)[number];

export const COLOR_CONFIG_KEYS: readonly (keyof Pick<IncidentItem, 'IncidentTypeID' | 'SeverityLevel'>)[] = [
  'IncidentTypeID',
  'SeverityLevel',
];

export const DEFAULT_INCIDENT_COLOR_KEY: keyof Pick<IncidentItem, 'IncidentTypeID' | 'SeverityLevel'> =
  'IncidentTypeID';

export type ColorScheme = {
  key: ColorConfigKey | null;
  scheme: ColorMap | null;
};

export type AvailableColorSchemes = Partial<Record<ColorConfigKey, MapToRecord<ColorMap>>>;
